import { Badge, Card } from '../ui';

interface Observation {
  id: number;
  spec_name: string;
  spec_unit?: string;
  value_numeric?: number;
  value_text?: string;
  value_boolean?: boolean;
  source_type: string;
  confidence: number;
  observed_date: string;
  notes?: string;
}

interface ObservationsGridProps {
  observations: Observation[];
  title?: string;
}

export const ObservationsGrid = ({ observations, title }: ObservationsGridProps) => {
  if (observations.length === 0) {
    return null;
  }

  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-50 mb-4">
        {title || 'Observed Data'}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {observations.map((obs) => {
          // Determine the value to display
          let displayValue = 'N/A';
          if (obs.value_numeric !== undefined && obs.value_numeric !== null) {
            displayValue = obs.value_numeric.toString();
          } else if (obs.value_text) {
            displayValue = obs.value_text;
          } else if (obs.value_boolean !== undefined && obs.value_boolean !== null) {
            displayValue = obs.value_boolean ? 'Yes' : 'No';
          }

          return (
            <div key={obs.id} className="p-3 border border-slate-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-900">
              <div className="flex justify-between items-start mb-1">
                <span className="font-medium text-sm text-slate-900 dark:text-slate-50">
                  {obs.spec_name}
                </span>
                <Badge variant={obs.confidence >= 4 ? 'approved' : 'default'} className="text-xs">
                  {obs.confidence}/5
                </Badge>
              </div>
              <div className="text-lg font-semibold text-blue-600 dark:text-blue-400 my-1">
                {displayValue}
                {obs.spec_unit && <span className="text-sm ml-1">{obs.spec_unit}</span>}
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400">
                {obs.source_type.replace('_', ' ')} • {new Date(obs.observed_date).toLocaleDateString()}
              </div>
              {obs.notes && (
                <div className="text-xs text-slate-600 dark:text-slate-300 mt-2 italic">
                  {obs.notes}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
};

